module.exports = __webpack_public_path__ + "img/arno-senoner-yqu6tJkSQ_k-unsplash.e1c2867b.jpg";